export const DOWNLOAD_CHAT_CONVERSATION_FAILURE = 'DOWNLOAD_CHAT_CONVERSATION_FAILURE';

export const downloadChatConversationFailure = error => ({
    type: DOWNLOAD_CHAT_CONVERSATION_FAILURE,
    payload: error,
    error: true,
});
